const links = [
  { label: 'Home', path: '/' },
  { label: 'Sobre nós', path: '/sobre-nos' },
  { label: 'Profissionais', path: '/profissionais' },
  { label: 'Contato', path: '/contato' },
];

export default links;
